import { useCallback, useState } from "react";

export const useForceRerender = () => {
  const [, setState] = useState(false);
  return useCallback(function forceRerender() {
    setState((prev) => !prev);
  }, []);
};
